var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    stroke: "current",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "current",
    clipPath: "url(#clip0_8650_12752)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    stroke: "current",
    d: "M6.92864 17.9275L1.21436 19.3561L2.64293 15.0704V2.21324C2.64293 1.83436 2.79344 1.471 3.06135 1.20309C3.32925 0.935178 3.69262 0.784668 4.0715 0.784668H18.3572C18.7361 0.784668 19.0995 0.935178 19.3674 1.20309C19.6353 1.471 19.7858 1.83436 19.7858 2.21324V16.499C19.7858 16.8778 19.6353 17.2412 19.3674 17.5091C19.0995 17.777 18.7361 17.9275 18.3572 17.9275H6.92864Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    stroke: "current",
    d: "M6.92847 7.21313H15.4999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    stroke: "current",
    d: "M6.92847 11.4988H12.6428",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    stroke: "current",
    id: "clip0_8650_12752"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "current",
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.0703125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.0205ac7ab6521e46bf551f4eaa41362c.svg";
export { ForwardRef as ReactComponent };